import { Badge, Btn } from "./UI";

const industryIcon = (ind) => {
  if (ind === "IT & Technology") return "💻";
  if (ind === "Real Estate")     return "🏢";
  if (ind === "Healthcare")      return "🏥";
  if (ind === "Finance")         return "💰";
  if (ind === "Education")       return "🎓";
  return "💼";
};

export default function JobsTab({
  jobs, loading,
  onCreateJob, onEditJob, onCloseJob, onDeleteJob,
  setSelectedJob, setTab,
}) {
  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 28 }}>
        <div>
          <h1 style={{ fontSize: 26, fontWeight: 800, color: "#0f172a", fontFamily: "'Playfair Display', serif", letterSpacing: "-0.4px" }}>
            My Jobs
          </h1>
          <p style={{ color: "#64748b", marginTop: 4, fontSize: 14 }}>
            {jobs.length} job listing{jobs.length !== 1 ? "s" : ""}
          </p>
        </div>
        <Btn onClick={onCreateJob}>+ Post New Job</Btn>
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: 80, color: "#94a3b8" }}>
          <div style={{ fontSize: 32, marginBottom: 12 }}>⏳</div>
          Loading jobs…
        </div>
      ) : jobs.length === 0 ? (
        <div style={{
          textAlign: "center", padding: 80,
          background: "#fff", borderRadius: 20, border: "1px solid #f1f5f9",
        }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>📋</div>
          <div style={{ color: "#64748b", fontSize: 16, marginBottom: 20 }}>No jobs posted yet.</div>
          <Btn onClick={onCreateJob}>Post Your First Job</Btn>
        </div>
      ) : (
        <div style={{ display: "grid", gap: 14 }}>
          {jobs.map(job => (
            <div key={job._id} style={{
              background: "#fff", borderRadius: 16, padding: "20px 22px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f1f5f9",
              display: "flex", gap: 16, alignItems: "flex-start",
              transition: "box-shadow 0.2s",
            }}
              onMouseOver={e => (e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.1)")}
              onMouseOut={e  => (e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)")}
            >
              {/* Icon */}
              <div style={{
                width: 50, height: 50, background: "#f1f5f9", borderRadius: 13,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 22, flexShrink: 0,
              }}>
                {industryIcon(job.industry)}
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                {/* Title + badge */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 8, marginBottom: 5 }}>
                  <div>
                    <div style={{ fontWeight: 700, color: "#0f172a", fontSize: 16 }}>{job.title}</div>
                    <div style={{ fontSize: 13, color: "#64748b", marginTop: 2 }}>
                      {job.company} · {job.city}, {job.state}
                    </div>
                  </div>
                  <Badge status={job.status} />
                </div>

                {/* Tags */}
                <div style={{ display: "flex", gap: 7, flexWrap: "wrap", marginBottom: 14 }}>
                  {[
                    `₹${(job.salaryMin / 1000).toFixed(0)}k – ₹${(job.salaryMax / 1000).toFixed(0)}k/mo`,
                    job.jobType,
                    job.experienceLevel,
                    `${job.totalApplicants ?? 0} applicant${(job.totalApplicants ?? 0) !== 1 ? "s" : ""}`,
                    `${job.totalOpenings} opening${job.totalOpenings !== 1 ? "s" : ""}`,
                  ].map((t, i) => (
                    <span key={i} style={{
                      background: "#f8fafc", border: "1px solid #e2e8f0",
                      color: "#475569", padding: "3px 10px", borderRadius: 8,
                      fontSize: 12, fontWeight: 500,
                    }}>{t}</span>
                  ))}
                </div>

                {/* Actions */}
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {job.totalApplicants > 0 && (
                    <Btn size="sm" variant="outline" onClick={() => { setSelectedJob(job); setTab("applicants"); }}>
                      View Applicants ({job.totalApplicants})
                    </Btn>
                  )}
                  {job.status !== "Closed" && (
                    <Btn size="sm" variant="secondary" onClick={() => onEditJob(job)}>Edit</Btn>
                  )}
                  {job.status !== "Closed" && (
                    <Btn size="sm" variant="danger" onClick={() => onCloseJob(job._id)}>Close Job</Btn>
                  )}
                  <Btn size="sm" variant="danger" onClick={() => onDeleteJob(job._id)}>Delete</Btn>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}